/**
 * CSV für Excel: Semikolon als Trenner, CRLF, UTF-8 mit BOM.
 *
 * Deutsches Excel öffnet die Datei per Doppelklick in Spalten und mit richtigen
 * Umlauten. Komma-getrennte Dateien landen dort sonst in einer einzigen Spalte,
 * und ohne BOM wird aus „Läuft" ein „LÃ¤uft".
 */

export type CsvValue = string | number | null | undefined;

/** Zellen mit Semikolon, Anführungszeichen oder Zeilenumbruch werden gequotet. */
export function csvCell(value: CsvValue): string {
  const text = value == null ? '' : String(value);
  return /[";\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function buildCsv(rows: CsvValue[][]): string {
  return `\uFEFF${rows.map((row) => row.map(csvCell).join(';')).join('\r\n')}\r\n`;
}

/** Dateiname aus beliebigem Text: „Curato GmbH & Co. KG" → „curato-gmbh-co-kg". */
export function fileSlug(value: string): string {
  return value
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function downloadCsv(filename: string, rows: CsvValue[][]): void {
  const blob = new Blob([buildCsv(rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
